import type { CmsItem, LenisLike } from '~/types/cms';

interface MenusState {
    menu_header: CmsItem[];
    menu_footer: CmsItem[];
    menu_footer_information: CmsItem[];
}

interface CategoriesState {
    news: CmsItem[];
    team: CmsItem[];
    folder: CmsItem[];
    faq: CmsItem[];
}

interface PageState {
    type: string;
    handle: string;
}

export const useMenusData = () =>
    useState<MenusState>('storeMenusData', () => ({
        menu_header: [],
        menu_footer: [],
        menu_footer_information: []
    }));

export const useCategoriesData = () =>
    useState<CategoriesState>('storeCategoriesData', () => ({
        news: [],
        team: [],
        folder: [],
        faq: []
    }));

export const usePageData = () =>
    useState<PageState>('statePageData', () => ({
        type: '',
        handle: ''
    }));

export const useScrollState = () => useState<number>('storeScrollState', () => 0);
export const useSettingsData = () => useState<CmsItem[]>('storeSettingsData', () => []);
export const useGlobalLoaded = () => useState<boolean>('stateGlobalLoaded', () => false);
export const usePageComplete = () => useState<boolean>('statePageComplete', () => false);
export const useShowMenu = () => useState<boolean>('stateShowMenu', () => false);
export const useShowPostCodeWidget = () => useState<boolean>('stateShowPostCodeWidget', () => false);
export const useShowModal = () => useState<boolean>('stateShowModal', () => false);
export const usePageBeforeComplete = () => useState<boolean>('statePageBeforeComplete', () => false);
export const useToggleMobileMenu = () => useState<boolean>('stateToggleMobileMenu', () => false);
export const useHeaderPrimed = () => useState<boolean>('stateHeaderPrimed', () => false);
export const useLenisData = () => useState<LenisLike | null>('stateLenisData', () => null);
